/** @jsxImportSource @emotion/react */
import { useEffect } from "react";
import { Card } from "primereact/card";
import { Boton, tituloBase, Titulo } from "../../shared";

// Ruta inexistente, en español y con salida al Inicio (el Router la usa como
// "*", igual que el admin)
export default function NotFound() {
  useEffect(() => {
    document.title = "Página no encontrada";
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Titulo urlVolver="/">Página no encontrada</Titulo>
      <Card css={{ marginBottom: "1em" }}>
        <div css={{ textAlign: "center", padding: "2em 1em", color: "var(--grisTextos)" }}>
          <i className="pi pi-compass" css={{ fontSize: "1.5rem" }} />
          <div css={{ fontWeight: 600, color: "rgba(44, 44, 44, 1)", marginTop: "0.5em" }}>
            Esta página no existe o se movió
          </div>
          <p css={{ margin: "0.25em 0 0" }}>Revisa el enlace o vuelve al inicio para seguir.</p>
          <div css={{ marginTop: "0.75em" }}>
            <Boton uri="/">Ir al inicio</Boton>
          </div>
        </div>
      </Card>
    </>
  );
}
